import { StorageHelper } from '@smg-real-estate/hg-search-libs';
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

import { HgLocalStorageKey } from '@/models';

import { StorageNamespace } from './storage-namespaces';

const storageHelper = new StorageHelper(StorageNamespace.searchAlerts);

export default function (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): void {
  if (storageHelper.isLocalStorageAvailable()) {
    let shouldReplace = false;
    if (to.query.email_token) {
      shouldReplace = true;
      const token = to.query.email_token;
      storageHelper.setLocalStorageItem(HgLocalStorageKey.SEARCH_ALERT_TOKEN, token);
      delete to.query.email_token;
    }

    if (to.query.action) {
      shouldReplace = true;
      const action = to.query.action;
      storageHelper.setLocalStorageItem(HgLocalStorageKey.PRICE_DROP_ALERT_ACTION, action);
      delete to.query.action;
    }

    if (shouldReplace) {
      next({
        query: to.query,
        path: to.path,
        replace: true,
      });
    } else {
      next();
    }
  } else {
    next();
  }
}
